<div class="text-center">
  <i class="fa {{params.icon}}" (click)="onClick()" aria-hidden="true"></i>
</div>